<!--
 * @Author: your name
 * @Date: 2020-09-15 14:29:18
 * @LastEditTime: 2022-11-02 14:57:05
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ConcreteCloud.Mobile\src\views\salesTerminal\abnormalMix\index.vue
-->
<template>
    <div class="abnormalMix">
        <van-nav-bar
            title="异常配比"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        ></van-nav-bar>
        <!-- <div class="search-time">
            <span class="time-item" @click="showCalendar(1, startTime)">{{ startTime }}</span>
            <span class="split"></span>
            <span class="time-item" @click="showCalendar(2, endTime)">{{ endTime }}</span>
        </div> -->
        <div class="block-con">
            <div
                class="block-item"
                v-for="(item, index) in blocks"
                :key="index"
                :class="{'active': index===activeIndex}"
                @click="changeBlock(index, item)"
            >
                <div>
                    <h4>{{ item.formula_count }}</h4>
                    <p>{{ item.name }}</p>
                </div>
            </div>
        </div>
        <div class="split-block"></div>
        <div class="wrapper">
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                <van-list
                    v-model="loading"
                    finished-text="没有更多了"
                    :finished="finished"
                    :immediate-check="false"
                    @load="onLoad"
                >
                    <ul v-if="formulaType===0">
                        <li
                            v-for="item in listData"
                            :key="item.formula_control_code"
                            class="item"
                        >
                            <div class="item-content">
                                <div class="row-tit">
                                    <span class="iconfont icondanjubianhao"></span>
                                    <span class="info">理论配比编号：{{ item.theory_formula_number }}</span>
                                </div>
                                <div class="row-item">
                                    <img src="@/assets/images/icons/icon_gy_1.png" alt="">
                                    <span class="info">异常配比管控编号：{{ item.formula_control_code }}</span>
                                </div>
                                <div class="row-item">
                                    <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                    <span class="info">
                                        理论配比名称：{{ item.theory_formula_name }}
                                    </span>
                                </div>
                                <div class="row-item">
                                    <img src="@/assets/images/icons/icon_gy_1.png" alt="">
                                    <span class="info">
                                        运营区配比编号：{{ item.theory_formula_number_yyq }}
                                    </span>
                                </div>
                                <div class="row-item">
                                    <img src="@/assets/images/icons/icon_32.png" alt="">
                                    <span class="info">
                                        异常配比内容：{{ item.control_content }},
                                    </span>
                                </div>
                                <div class="row-item">
                                    <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                    <span class="info">
                                        异常管控时间：{{ item.control_start_time }}
                                    </span>
                                </div>
                                <div class="row-item">
                                    <img src="@/assets/images/icons/icon_3.png" alt="">
                                    <span class="info">操作员：{{ item.publish_user }}</span>
                                </div>
                            </div>
                            <div class="notice-btn" @click="noticePop(item.control_msg)">
                                管控通知详情 >>
                            </div>
                        </li>
                    </ul>
                    <ul v-else-if="formulaType===1">
                        <li
                            v-for="item in listData"
                            :key="item.formula_control_code"
                            class="item"
                        >
                            <div class="item-content">
                                <div class="row-tit">
                                    <span class="iconfont icondanjubianhao"></span>
                                    <span class="info">试验配比编号：{{ item.experiment_formula_number }}</span>
                                </div>
                                <div class="row-item">
                                    <img src="@/assets/images/icons/icon_gy_1.png" alt="">
                                    <span class="info">异常配比管控编号：{{ item.formula_control_code }}</span>
                                </div>
                                <div class="row-item">
                                    <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                    <span class="info">
                                        试验配比名称：{{ item.experiment_formula_name }}
                                    </span>
                                </div>
                                <div class="row-item">
                                    <img src="@/assets/images/icons/icon_32.png" alt="">
                                    <span class="info">
                                        异常配比内容：{{ item.control_content }},
                                    </span>
                                </div>
                                <div class="row-item">
                                    <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                    <span class="info">
                                        异常管控时间：{{ item.control_start_time }}
                                    </span>
                                </div>
                                <div class="row-item">
                                    <img src="@/assets/images/icons/icon_3.png" alt="">
                                    <span class="info">操作员：{{ item.publish_user }}</span>
                                </div>
                                <div class="row-item">
                                    <img src="@/assets/images/icons/icon_gy_8.png" alt="">
                                    <span class="info">场站：{{ item.station_name }}</span>
                                </div>
                                <div class="row-item">
                                    <img src="@/assets/images/icons/icon_gy_1.png" alt="">
                                    <span class="info">理论配比编号：{{ item.theory_formula_number }}</span>
                                </div>
                            </div>
                            <div class="notice-btn" @click="noticePop(item.control_msg)">
                                管控通知详情 >>
                            </div>
                        </li>
                    </ul>
                    <ul v-else-if="formulaType===2">
                        <li
                            v-for="item in listData"
                            :key="item.formula_control_code"
                            class="item"
                        >
                            <div class="item-content">
                                <div class="row-tit">
                                    <span class="iconfont icondanjubianhao"></span>
                                    <span class="info">施工配比编号：{{ item.product_formula_number }}</span>
                                </div>
                                <div class="row-item">
                                    <img src="@/assets/images/icons/icon_gy_1.png" alt="">
                                    <span class="info">异常配比管控编号：{{ item.formula_control_code }}</span>
                                </div>
                                <div class="row-item">
                                    <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                    <span class="info">
                                        任务单号：{{ item.task_number }}
                                    </span>
                                </div>
                                <div class="row-item">
                                    <img src="@/assets/images/icons/icon_32.png" alt="">
                                    <span class="info">
                                        异常配比内容：{{ item.control_content }},
                                    </span>
                                </div>
                                <div class="row-item">
                                    <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                    <span class="info">
                                        异常管控时间：{{ item.control_start_time }}
                                    </span>
                                </div>
                                <div class="row-item">
                                    <img src="@/assets/images/icons/icon_3.png" alt="">
                                    <span class="info">操作员：{{ item.publish_user }}</span>
                                </div>
                                <div class="row-item">
                                    <img src="@/assets/images/icons/icon_gy_8.png" alt="">
                                    <span class="info">场站：{{ item.station_name }}</span>
                                </div>
                                <div class="row-item">
                                    <img src="@/assets/images/icons/icon_gy_8.png" alt="">
                                    <span class="info">生产机组：{{ item.line_name }}</span>
                                </div>
                                <div class="row-item">
                                    <img src="@/assets/images/icons/icon_gy_1.png" alt="">
                                    <span class="info">配比类型：{{ item.formula_type_name }}</span>
                                </div>
                                <div class="row-item">
                                    <img src="@/assets/images/icons/icon_gy_1.png" alt="">
                                    <span class="info">试验配比编号：{{ item.line_experiment_formula_number }}</span>
                                </div>
                            </div>
                            <div class="notice-btn" @click="noticePop(item.control_msg)">
                                管控通知详情 >>
                            </div>
                        </li>
                    </ul>
                </van-list>
            </van-pull-refresh>
        </div>


        <van-popup v-model="showCalendarPop" position="bottom" :style="{ height: '50%' }">
            <van-datetime-picker
                v-model="currentDate"
                type="date"
                title="选择年月日"
                @confirm="confirmDate"
                @cancel="cancelDate"
            ></van-datetime-picker>
        </van-popup>
    </div>
</template>

<script>
import util from '@/utils/util';
import { Dialog } from 'vant';
export default {
    components: {},
    props: {},
    data() {
        return {
            // 统计块数据
            blocks: [],
            activeIndex: 0,
            // 菜单类型
            formulaType: null,
            // 时间筛选
            showCalendarPop: false,
            currentDate: new Date(),
            pickTimeType: 1,
            startTime: '',
            endTime: '',
            // 异常配比列表数据
            listData: [],
            loading: false,
            finished: false,
            pageindex: 0,
            isLoading: false,
        };
    },
    watch: {},
    computed: {},
    created() {
        this.init();
    },
    mounted() {},
    methods: {
        init() {
            const endTime = util.currentTimeFormat('yyyy-MM-dd');
            const date = new Date();
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            const startTime = year + '-' + month + '-01';
            this.startTime = startTime;
            this.endTime = endTime;
            this.handleGroupTotal();
        },

        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 切换配比类型
        changeBlock(index, item) {
            this.formulaType = item.formula_type;
            this.activeIndex = index;
            this.pageindex = 0;
            this.finished = false;
            this.loading = true;
            this.listData = [];
            this.onLoad();
        },
        // 弹出管控消息
        noticePop(msg) {
            Dialog.alert({
                message: msg,
                confirmButtonColor: '#E60000',
            }).then(() => {
                // on close
            });
        },
        // 处理异常配比合计数量
        async handleGroupTotal() {
            const res = await this.getGroupTotal();
            if (res) {
                const nameArr = ['理论配比(个)', '试验配比(个)', '施工配比(个)'];
                res.map(item => {
                    item.name = nameArr[item.formula_type];
                    return item;
                });
                // 基础版不显示理论配比
                if (this.$store.state.versionMark === '1') {
                    this.blocks = res.filter(item => item.formula_type !== 0);

                } else {
                    this.blocks = res;
                }
                this.formulaType = this.blocks[0].formula_type;
                this.onLoad();
            }
        },
        // 下拉刷新
        onRefresh() {
            this.pageindex = 0;
            this.finished = false;
            this.loading = true;
            this.listData = [];
            this.onLoad();
        },
        // 分页拉取
        onLoad() {
            if (this.isLoading) {
                this.listData = [];
                this.isLoading = false;
            }
            this.pageindex += 1;
            this.handleTheoryControl();
        },
        // 处理异常理论配比
        async handleTheoryControl() {
            const res = await this.getTheoryControl();
            if (res) {
                // this.listData = res;
                // this.showOverlay = false;
                this.loading = false;
                this.isLoading = false;
                if (res.total) {
                    this.total = true;
                    this.listData = this.listData.concat(res.rows);
                    if (this.listData.length >= res.total) {
                        this.finished = true;
                    }
                } else {
                    this.total = false;
                    this.finished = true;
                }
            }
        },
        // 拉取异常配比合计数量
        getGroupTotal() {
            const path = '/interfaceApi/production/formulacontrol/group_total';
            return this.$axios.$get(path, { defEx: true });
        },
        // 拉取异常理论配比
        getTheoryControl() {
            let path = '';
            if (this.formulaType === 0) {
                path = '/interfaceApi/production/formulacontrol/theory_control';
            } else if (this.formulaType === 1) {
                path = '/interfaceApi/production/formulacontrol/experiment_control';
            } else if (this.formulaType === 2) {
                path = '/interfaceApi/production/formulacontrol/product_control';
            }
            path += '?pageindex=' + this.pageindex + '&pagesize=3';
            return this.$axios.$get(path, { defEx: true });
        },

        // 展示日历
        showCalendar(type, time) {
            this.pickTimeType = type;
            const timeArr = time.split('-');
            this.currentDate = new Date(timeArr[0], timeArr[1] - 1, timeArr[2]);
            this.showCalendarPop = true;
        },
        confirmDate(value) {
            this.showCalendarPop = false;
            if (this.pickTimeType === 1) {
                this.startTime = this.formatDate(value);
            } else {
                this.endTime = this.formatDate(value);
            }
            this.handleDeliveryStatistics();
        },
        cancelDate() {
            this.showCalendarPop = false;
        },
        formatDate(date) {
            date = new Date(date);
            const y = date.getFullYear();
            let m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            let d = date.getDate() + 1;
            d = d < 10 ? '0' + d : d;
            return y + '-' + m + '-' + d;
        },


    },
};
</script>
<style lang="stylus">
.abnormalMix
    height 100%
    background #F0F0F0
    .search-time
        height 30rpx
        text-align center
        line-height 30rpx
        .split
            width 10rpx
            height 1px
            background #979EA7
            display inline-block
            vertical-align middle
            margin 0 10rpx
        .time-item
            vertical-align middle
    .block-con
        padding 15rpx 7rpx
        background #fff
        display flex
        justify-content space-around
        .block-item
            flex 1
            height 57rpx
            margin 0 7rpx
            text-align center
            color #5588F1
            >div
                height 50rpx
                background rgba(85, 136, 241, 0.1)
                border-radius 4rpx
                h4
                    font-size 16rpx
                    padding 3rpx 0 0 0
                p
                    font-size 12rpx
            &.active
                background url(./../../../assets/images/sales/abnormalMix_bg.png) no-repeat
                background-size 100% 100%
                color #fff
    .split-block
        height 15rpx
    .wrapper
        height calc(100% - 142rpx)
        overflow-y auto
        ul
            padding 0 15rpx 15rpx 15rpx
            .item
                margin-bottom 15rpx
                background #ffffff
                border-radius 4rpx
                .item-content
                    overflow hidden
                    padding 15rpx
                    p
                        width 50%
                        float left
                        line-height 30rpx
                        font-size 14rpx
                        color #666666
                        img
                            width 14rpx
                            margin-right 10rpx
                            vertical-align middle
                    .row-item
                        line-height 21rpx
                        margin-top 10rpx
                        img
                            width 14rpx
                            vertical-align middle
                            margin-right 5rpx
                        .info
                            font-size 14rpx
                            color #666666
                            vertical-align middle
                    .row-tit
                        font-size 15rpx
                        .iconfont
                            color #3394FA
                            margin-right 5rpx
                        .info
                            font-weight bold
                .notice-btn
                    height 40rpx
                    background #F9FCFE
                    text-align center
                    line-height 40rpx
                    color #E60000
                    font-size 14rpx
                    border-radius 0 0 4rpx 4rpx

</style>
